import React from 'react';

import './placeholder.scss';

const LogoPlaceholder = () => {
  return <div className="hc-logo-placeholder" />;
};

export { LogoPlaceholder };
